import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './GridImage.css';

const GridImage = ({ lightboxUrl, imageUrl, auctionTitle }) => (
    <Link
        to={lightboxUrl}
        title={`Click for larger images of ${auctionTitle}`}
        className="al-grid-image"
    >
        <img
            src={imageUrl}
            alt={`${auctionTitle} preview`}
            loading="lazy"
        />
    </Link>
);

GridImage.propTypes = {
    lightboxUrl: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    auctionTitle: PropTypes.string
};

export default GridImage;
